import { pgTable, uuid, timestamp, varchar, index, boolean } from 'drizzle-orm/pg-core';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  external_id: uuid('external_id').defaultRandom().notNull().unique(),
  email: varchar('email', { length: 64 }).notNull().unique(),
  password: varchar('password', { length: 256 }),
  emailVerified: boolean('emailVerified').$defaultFn(() => false).notNull(),
  createdAt: timestamp('createdAt', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  updatedAt: timestamp('updatedAt', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
}

/**
 * @ignore
 **/
export const users = pgTable(
  'Users', 
  schema,
  (table) => [
    index('user_external_id_idx').on(table.external_id),
  ]
); 